import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { SyncMultiTenantOrganizationDetailsActions } from '../../domains/multiTenantOrganizationSyncDetails/actions.types';
import type { MultiTenantOrganizationSyncDetailsLifecycle } from '../types';

const initialState: MultiTenantOrganizationSyncDetailsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<MultiTenantOrganizationSyncDetailsLifecycle, SyncMultiTenantOrganizationDetailsActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MULTI_TENANT_ORGANIZATION.SYNC_PENDING':
      return setPending();
    case 'MULTI_TENANT_ORGANIZATION.SYNC_FULFILLED':
      return setFulfilled(action.payload.entities);
    case 'MULTI_TENANT_ORGANIZATION.SYNC_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
